export const radiobuttonTokens = {
  radiobutton: {
    root: {
      width: '1.25rem',
      height: '1.25rem',
      shadow: 'none',
      transitionDuration: '{transition.duration}',
      focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
      }
    },
    icon: {
      size: '0.375rem'
    },
    colorScheme: {
      light: {
        root: {
          background: '{surface.0}',
          checkedBackground: '{surface.0}',
          checkedHoverBackground: '{surface.0}',
          disabledBackground: '{surface.300}',
          filledBackground: '{surface.100}',
          borderColor: '{surface.500}',
          hoverBorderColor: '{surface.600}',
          focusBorderColor: '{primary.color}',
          checkedBorderColor: '{primary.color}',
          checkedHoverBorderColor: '{primary.color}',
          checkedFocusBorderColor: '{primary.color}',
          checkedDisabledBorderColor: '{surface.400}',
          invalidBorderColor: '{formField.invalidBorderColor}'
        },
        icon: {
          checkedColor: '{primary.color}',
          checkedHoverColor: '{primary.color}',
          disabledColor: '{surface.500}'
        }
      }
    }
  }
};

export type RadioButtonTokens = typeof radiobuttonTokens;
